exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-wrapper,.select-wrapper .custom-select{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.select-wrapper .custom-select select{border-color:#e0e0e0!important}.select-wrapper .custom-select select option:disabled{color:#fff;background:#dc3545}small.error{color:#dc3545}", ""]);

// exports
